import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkySmlouvySearch } from '@/lib/list-search';

const NabidkaDetail = lazy(() =>
  import('@/modules/vozidla/NabidkaDetail').then((m) => ({ default: m.NabidkaDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/nabidky/$id',
  component: () => (
    <Suspense fallback={null}>
      <NabidkaDetail />
    </Suspense>
  ),
  // Same shape as the list route so the detail's master rail shows the same
  // cohort (name + number filters) the user was browsing.
  validateSearch: parseNabidkySmlouvySearch,
});
